module.exports = __webpack_public_path__ + "img/SZ.16d57e18.svg";